import React, { useState, useEffect } from "react";

import team from '../Assets/girl.png'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import GetSeodata from "../Components/GetSeodata";

function Teams() {
  const [activeTab, setActiveTab] = useState(1);
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <>
        <Navbar/>
        <GetSeodata PageName={'teams'} />
        <div className='about-div'>
        <h1>Our Team</h1>
        <p><i>Home - Team</i></p>

        </div>

        <div className="tab-container">
                <div className="tabs">
                  <button
                    className={activeTab === 1 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(1)}>
                    India Sales
                  </button>
                  <button
                    className={activeTab === 2 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(2)}>
                                        Combaodia  Sales

                  </button>
                  <button
                    className={activeTab === 3 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(3)}>
                                        Vietnam  Sales

                  </button>
                  <button
                    className={activeTab === 4 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(4)}>
                    Indonesia Sales
                  </button>
                </div>

                <br />
                
                <div className="tab-content">
                  {activeTab === 1 && (
                   <>
                    <div className="team-cards">
                    <div className="team-card">
                    <img src={team}/>
                    <br/>
                   <div className="team-card-text">
                   <h3>Name OF Team</h3>
                   <p><b>CEO </b></p>
                   <p>+66 934816498 </p>
                   <p>ops.thailand@expelra.co.th </p>

                   </div>
</div>
    <div className="team-card">
                    <img src={team}/>
                    <br/>
                   <div className="team-card-text">
                   <h3>Name OF Team</h3>
                   <p><b>CEO </b></p>
                   <p>+66 934816498 </p>
                   <p>ops.thailand@expelra.co.th </p>

                   </div>
</div>
                    </div>
                   </>
                  )}
                  {activeTab === 2 && (
                    <>
                    <div className="team-cards">
                    <div className="team-card">
                    <img src={team}/>
                    <br/>
                    <h3>Name OF Team</h3>
                    <p>CEO </p>
</div>
  <div className="team-card">
                    <img src={team}/>
                    <br/>
                    <h3>Name OF Team</h3>
                    <p>CEO </p>
</div>
  <div className="team-card">
                    <img src={team}/>
                    <br/>
                    <h3>Name OF Team</h3>
                    <p>CEO </p>
</div>
                    </div>
                   </>
                  )}

                  {activeTab === 3 && (
                    <>
                    <div className="team-cards">
                    <div className="team-card">
                    <img src={team}/>
                    <br/>
                    <h3>Name OF Team</h3>
                    <p>CEO </p>
</div>
  <div className="team-card">
                    <img src={team}/>
                    <br/>
                    <h3>Name OF Team</h3>
                    <p>CEO </p>
</div>
  <div className="team-card">
                    <img src={team}/>
                    <br/>
                    <h3>Name OF Team</h3>
                    <p>CEO </p>
</div>
                    </div>
                   </>
                  )}
                </div>
              </div>
        <Footer/>
    </>
  )
}

export default Teams